export default __webpack_public_path__ + "static/andrii-kukliak-d90978f3525d21678926afc231debf79.png";